import {Box, MobileStepper} from '@mui/material'
import React from 'react'

type Props = {
  activeStep: number
  stoppagesCount: number
}

export const UndefinedStoppagesStepper: React.FC<Props> = ({activeStep, stoppagesCount}) => (
  <Box sx={{display: 'flex', justifyContent: 'center', backgroundColor: 'transparent'}}>
    <MobileStepper
      variant="dots"
      steps={stoppagesCount}
      position="static"
      activeStep={activeStep}
      sx={{
        maxWidth: 300,
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        '& .MuiMobileStepper-dots': {
          justifyContent: 'center',
          display: 'flex',
          width: '100%'
        },
        backgroundColor: 'transparent',
        '& .MuiMobileStepper-dotActive': {
          backgroundColor: 'white'
        }
      }}
      backButton={null}
      nextButton={null}
    />
  </Box>
)
